import { PAYMENT_API_HASH_SECURITY_KEY, PAYMENT_GEO_URL } from 'lib/paymentApi/constants';
import hashUserData from 'utils/dataUtils/hashUserData';
import type { RegistrationSource } from '@/app_lib/types/Piano';

export async function geoIp(pianoUid: string, registrationSource: RegistrationSource): Promise<void> {
  const hashedUserData = hashUserData(pianoUid, PAYMENT_API_HASH_SECURITY_KEY);
  await fetch(`${PAYMENT_GEO_URL}?pianoUID=${pianoUid}&registrationSource=${registrationSource}&hash=${hashedUserData}`)
    .then((response) => response.json())
    .then((data) => {
      // biome-ignore lint/suspicious/noConsole: This is for debugging purposes
      console.info('Success:', data);
    })
    .catch((error) => {
      // biome-ignore lint/suspicious/noConsole: This is for debugging purposes
      console.error('Error:', error);
    });
}
